import { useRouter } from 'next/router'

import { useCountryFromRegionProvider } from '@cash-web/shared-region-ui-context-main'
import { defaultRegion, supportedRegions } from '@cash-web/support/utils-region-config'

const contactArticleToken = process.env['NEXT_PUBLIC_CONTACT_ARTICLE_ID']

/**
 * `/contact` always serves the region's default locale, and the help center has no `contact` alias under a locale
 * segment, so other locales link to the contact article itself.
 * @returns the localized contact article path, or `undefined` to keep the default `/contact` link
 */
const useContactHref = (): string | undefined => {
  const { locale } = useRouter()
  const region = useCountryFromRegionProvider()?.toLowerCase() ?? defaultRegion
  const regionConfig = supportedRegions[region as keyof typeof supportedRegions]

  if (!contactArticleToken || !locale || !regionConfig || locale === regionConfig.defaultLocale) return undefined
  if (!(regionConfig.supportedLocales as ReadonlyArray<string>).includes(locale)) return undefined

  return `/help/${regionConfig.region}/${locale}/${contactArticleToken}-contact-cash-support`
}

export default useContactHref
